// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3jMEU","itemTitle":"ClientEmergencyInfo_itemTitle__2Nhp7","itemText":"ClientEmergencyInfo_itemText__3xQ3n"};